import Image from 'next/legacy/image';

import { NavigationButton } from '@common/buttons';
import colours from '@common/colours';
import { Banner } from '../Banner/Banner';

import { APP_STORE_DOWNLOAD_LINKS } from '../../nextConstants/appStoreConstants';

import googlePlayStore from '@public/img/icons/google-play-store.png';
import appleAppStore from '@public/img/icons/apple-app-store.svg';

type Props = {
  trackingId?: string;
};

export const DownloadAppBanner = ({ trackingId }: Props): JSX.Element => {
  const redirectToLink = (link: string, openWindow = false) => {
    if (window.mixpanel?.track && trackingId) {
      window.mixpanel.track('Clicked Download App', { location: trackingId });
    }
    if (!openWindow) {
      window.location.href = link;
    } else {
      const newWindow = window.open(link, '_blank', 'noopener,noreferrer');
      if (newWindow) {
        newWindow.opener = null;
      }
    }
  };
  return (
    <>
      <div className="download-app-banner-container flex flex-col">
        <Banner
          title={
            'Join our community for tips and motivation. Get the free app.'
          }
          showActions
          desktopAction={
            <div className="app-store-links">
              <a
                href="#"
                onClick={() =>
                  redirectToLink(
                    APP_STORE_DOWNLOAD_LINKS.appleAppStoreLink,
                    true,
                  )
                }
              >
                <Image
                  src={appleAppStore}
                  alt="Apple App Store"
                  width={151}
                  height={45}
                  layout="fixed"
                />
              </a>
              <a
                href="#"
                onClick={() =>
                  redirectToLink(
                    APP_STORE_DOWNLOAD_LINKS.googlePlayStoreLink,
                    true,
                  )
                }
              >
                <Image
                  src={googlePlayStore}
                  alt="Google Play Store"
                  width={151}
                  height={45}
                  layout="fixed"
                />
              </a>
            </div>
          }
          mobileAction={
            <div className="download-app-button">
              <NavigationButton
                href="#"
                onClick={() => redirectToLink('/download-app')}
                isExternalLink
                color={colours.snBlue}
                backgroundColor="#FFFFFF"
                borderRadius={25}
                paddingTop={4}
                paddingSide={12}
                height={26}
              >
                Get app
              </NavigationButton>
            </div>
          }
        />
      </div>
      <style jsx>{`
        .download-app-banner-container {
          width: 100vw;
          flex: 1;
          left: 0;
          bottom: 0;
          margin: auto;
          height: 100%;
        }
        .app-store-links {
          display: none;
          max-height: 500px;
        }
        .download-app-button {
          padding-top: 34px;
        }
        @media (min-width: 767px) {
          .app-store-links {
            display: flex;
            flex-direction: row;
            margin-top: 32px;
            max-width: 50%;
            margin-top: 24px;
            margin-bottom: 0px;
          }
        }

        .app-store-links > *:first-child {
          margin-right: 16px;
        }
        .qr-container {
          display: none;
        }
        .qr-image {
          margin: 16px 0;
        }
        @media (min-width: 767px) {
          .qr-container {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .qr-image {
            padding: 10px;
            background-color: ${colours.white};
            filter: drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.15));
            border-radius: 8px;
          }
        }
        .download-app-button {
          display: flex;
          justify-content: center;
        }
        @media (min-width: 767px) {
          .download-app-button {
            display: none;
          }
        }
        .content-container {
          margin-bottom: 24px;
        }
        .restart-content {
          display: flex;
          flex-direction: column;
          text-align: center;
        }
      `}</style>
    </>
  );
};
